import { SharepointData } from "./sharepoint.data";
import React, { useMemo } from "react";
import { useAttributeValueComponents, IconAndTitle, useRenderers } from "@me8eon/renderers";
import { useCommonComponents } from "@me8eon/components";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
// @ts-ignore
import icon from "./sharepoint.svg";
import { SimpleWidget } from "@me8eon/simple_widget";

export const SharepointDisplay: DisplayData<SharepointData> =
    ({ rootId, id, data }: DisplayDataProps<SharepointData>) => {
        const { H1WithIconAndUrl, Html, Url } = useRenderers();
        const { Text, Date, DataLayout } = useAttributeValueComponents();
        const ClipHeight = useCommonComponents().ClipHeight;
        const newRootId = `${rootId}.${id}`;
        const url = `${data.resource.webUrl}?web=1`;
        const titleAndUrl = useMemo(() => ({ title: data.resource.name, url, icon }), [data.resource.name, url]);
        return <DataLayout rootId={newRootId} className="sharepoint-data" layout={[1, 1, 3, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData("name")} value={titleAndUrl} />
            {data.summary && <ClipHeight maxHeight="2rem" force={false}>
                {/*<HighlightKeyWords rootId={newRootId} attribute='title' value={data.title}/>*/}
                <Html rootId={newRootId} attribute={translateLabelForData("desc")} value={data.summary} />
            </ClipHeight>}
            <Text rootId={newRootId} attribute={translateLabelForData("createdBy")} value={data.resource.createdBy.user.displayName} />
            <Date rootId={newRootId} attribute={translateLabelForData("createdOn")} value={data.resource.createdDateTime} />
            <Date rootId={newRootId} attribute={translateLabelForData("lastUpdate")} value={data.resource.lastModifiedDateTime} />
            <Url rootId={newRootId} attribute={translateLabelForData("url")} value={`${data.resource.webUrl}?web=1`} />
        </DataLayout>;
    };

export const SimpleSharepointOneLineDisplay: DisplayData<SharepointData> =
    ({ data, listItemClicked }: DisplayDataProps<SharepointData>) => {
        const { SearchListItem } = useRenderers();
        const issueSummaryAndUrl: IconAndTitle = useMemo(() =>
        ({
            title: `${data.resource.name}`,
            icon: icon,
            onClick: () => { listItemClicked && listItemClicked(`${data.resource.name}`); },
        }), [data.summary]);
        return (
            <SearchListItem key={data.resource.name} rootId={data.resource.name} attribute={translateLabelForData("name")} value={issueSummaryAndUrl} />
        );
    };

export const SimpleSharepointWidget: DisplayDataWidget<SharepointData> =
    SimpleWidget<SharepointData>(["name", "description"], [], []);
